/*
 *  Date Countdown
 *    Scripts for the date countdown
 *
 *  Version:
 *    1.0.0
 */

const SELECTOR_CONTAINER = '[data-date-countdown]';

document
  .querySelectorAll<HTMLSpanElement>(SELECTOR_CONTAINER)
  .forEach((container) => {
    const date = container.getAttribute('data-date-countdown');
    const countDownDate = new Date(date).getTime();
    const daysElement = container.querySelector('[data-date-countdown-days]');
    const hoursElement = container.querySelector('[data-date-countdown-hours]');
    const minutesElement = container.querySelector('[data-date-countdown-minutes]');
    const secondsElement = container.querySelector('[data-date-countdown-seconds]');

    // Update the count down every 1 second
    const count = setInterval(function () {
      // Get today's date and time
      const now = new Date().getTime();

      // Find the distance between now and the count down date
      const distance = countDownDate - now;

      // Time calculations for days, hours, minutes and seconds
      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      // Display the result in the associated elements
      daysElement.innerHTML = `${days} <span>Days</span>`;
      hoursElement.innerHTML = `${hours} <span>Hours</span>`;
      minutesElement.innerHTML = `${minutes} <span>Minutes</span>`;
      secondsElement.innerHTML = `${seconds} <span>Seconds</span>`;

      // If the count down is finished, write some text
      if (distance < 0) {
        clearInterval(count);
        daysElement.innerHTML = '00 <span>Days</span>';
        hoursElement.innerHTML = '00 <span>Hours</span>';
        minutesElement.innerHTML = '00 <span>Minutes</span>';
        secondsElement.innerHTML = '00 <span>Seconds</span>';
      }
    }, 1000);
  });
